import React from 'react'
function EmptyTodos() {

  return (
<p>Crear tu primer TODO!</p>  )
}

export {EmptyTodos}